import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/privacy-policy-new/page.tsx");
